import React, { useEffect, useState, useCallback, useRef } from 'react';
import ChartScreen from './ChartScreen';
import { Container, Input, CustomInput } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DashBoardCard from './DashBoardCard';
import { useDispatch, useSelector } from 'react-redux';
import { fetchChartData, fetchMachineListByCompanyId } from './redux/dispatcher';
import { fetchCompanyList } from 'components/companyList/redux/dispatcher';
import Loader from 'commonComponents/Loader';
import AlertNotification from 'components/alertNotification/AlertNotification';
import Header from './Header';
import { Autocomplete, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import './Dashboard.css'
import { errorChartDataDashBoard } from './redux/action';
import useClickOutside from 'commonComponents/useClickOutSide';

const CustomInputBox = styled(Autocomplete)(({ theme }) => ({
  width: '100%',
  height: '54px',
  background: 'rgba(255, 255, 255, 1)',

}));

const Dashboard = () => {
  const dispatch = useDispatch();
  const companyListData = useSelector((state) => state.companyListReducer.data?.data || []);
  const machineListData = useSelector((state) => state.dashboardReducer.machinListByCompanyId || []);
  const chartData = useSelector((state) => state?.dashboardReducer?.chartData?.res || []);
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState('');
  const [machineList, setMachineList] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState([]);
  const [filteredMachineList, setFilteredMachineList] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [isAllMachineSelect, setIsAllMachineSelect] = useState(false);
  const [today] = useState(new Date());
  const [dateRange, setDateRange] = useState([new Date(today.setDate(today.getDate() - 6)), new Date()]);
  const [startDate, endDate] = dateRange;
  const [loader, setLoader] = useState(false);
  const dropdownRef = useRef(null);
  const anotherRef = useRef(null);


  useEffect(() => {
    // setLoader(true)
    // setTimeout(() => {
    //   setLoader(false)
    // }, 2000);
  }, [])

  useEffect(() => {
    dispatch(fetchCompanyList());
  }, [dispatch]);

  useEffect(() => {
    setCompanyList(companyListData);
    const firstCompanyId = companyListData[0]?.id || '';
    setSelectedCompany(firstCompanyId);
  }, [companyListData]);

  useEffect(() => {
    dispatch(fetchMachineListByCompanyId(selectedCompany));
  }, [selectedCompany, dispatch]);

  useEffect(() => {
    setMachineList(machineListData);

    if (machineListData.length > 0 && selectedMachine.length === 0) {
      setSelectedMachine([String(machineListData[0].machine_id)]);
    }
  }, [machineListData]);

  // Update isAllMachineSelect when selectedMachine changes
  useEffect(() => {
    setIsAllMachineSelect(
      machineList.length > 0 && selectedMachine.length === machineList.length
    );
  }, [selectedMachine, machineList]);

  // Update filtered machine list to show all machines
  useEffect(() => {
    setFilteredMachineList(machineList);
  }, [machineList]);

  const fetchChart = useCallback(() => {
    if (!selectedMachine.length || !selectedCompany || !startDate || !endDate) {
      return dispatch(errorChartDataDashBoard(''))
    }
    dispatch(fetchChartData({
      id: selectedMachine,
      company_id: selectedCompany,
      startDate: convertDateString(startDate),
      endDate: convertDateString(endDate),
    }));
  }, [selectedMachine, selectedCompany, startDate, endDate]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchChart();
    }, 500);

    return () => clearTimeout(timer);
  }, [fetchChart]);

  function convertDateString(dateString) {
    let date = new Date(dateString);
    let year = date.getFullYear();
    let month = String(date.getMonth() + 1).padStart(2, '0');
    let day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const handleCompanyChange = (event, newValue) => {
    setSelectedCompany(newValue?.id || '');
    setSelectedMachine([]);
    setMachineList([]);
  };

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const handleMachineSelection = (e) => {
    const selectedValue = String(e.target.value);
    let updatedSelectedMachines;
    if (selectedMachine.includes(selectedValue)) {
      updatedSelectedMachines = selectedMachine.filter(machine => machine !== selectedValue);
    } else {
      updatedSelectedMachines = [...selectedMachine, selectedValue];
    }
    setSelectedMachine(updatedSelectedMachines);
  };

  const toggleSelectAll = () => {
    if (isAllMachineSelect) {
      setSelectedMachine([]);
    } else {
      setSelectedMachine(machineList.map(machine => String(machine.machine_id)));
    }
  };


  // Close dropdown when clicking outside
  useClickOutside(
    [dropdownRef, anotherRef],
    () => setDropdownVisible(false),
    dropdownVisible
  );

  if (loader) {
    return (
      <Loader />
    )
  }

  const handleDateChange = () => {
    // Date validation logic here
  };

  return (

    <>
      <Header />
      <Container fluid className="mt-2 dashboard_body">
        <Box sx={{ flexGrow: 1, }} >

          <Grid container spacing={2} className='mt-2'>
            <Grid item xs={12} container spacing={3.5} className='mb--2'>

              {/* company drop down */}
              <Grid item xs={4}>
                <CustomInputBox
                  disablePortal
                  id="selectCompany"
                  getOptionLabel={(option) => option?.company_name || ''}
                  options={companyList}
                  value={companyList.find((company) => company.id === selectedCompany) || null}
                  onChange={handleCompanyChange}
                  renderInput={(params) => <TextField {...params}
                    label={companyList.length === 0 ? 'No company found' : (
                      <>
                        Company <span style={{ color: 'red' }}>*</span>
                      </>
                    )} />}
                  disabled={companyList.length === 0}
                />
              </Grid>

              {/* machine drop down */}
              <Grid item xs={4}>
                <div
                  onClick={toggleDropdown}
                  style={{
                    cursor: 'pointer',
                    border: '1px solid #ced4da',
                    padding: '16px 14px',
                    borderRadius: '4px',
                    position: 'relative',
                    backgroundColor: 'white',
                    height: '56px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                  ref={anotherRef}
                >
                  <div className="d-flex justify-content-between w-100">
                    <span style={{ color: selectedMachine.length > 0 ? '#000' : '#8898AA' }}>
                      {selectedMachine.length > 0
                        ? selectedMachine.length + " Machine(s) Selected"
                        : "Select Machine(s)"}
                    </span>
                    <span>
                      <i
                        className={`fa-solid fa-caret-${dropdownVisible ? "up" : "down"
                          }`}
                      ></i>
                    </span>
                  </div>
                  {/* Required asterisk */}
                  <span style={{
                    position: 'absolute',
                    top: '-8px',
                    left: '12px',
                    background: 'white',
                    padding: '0 4px',
                    fontSize: '12px',
                    color: '#666'
                  }}>
                    Machine <span style={{ color: 'red' }}>*</span>
                  </span>
                </div>

                {dropdownVisible && (
                  <div
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                      border: "1px solid #ced4da",
                      padding: "10px",
                      borderRadius: "4px",
                      position: "absolute",
                      zIndex: 50,
                      width: "30%",
                      backgroundColor: "white",
                      marginTop: "2px"
                    }}
                    ref={dropdownRef}
                  >

                    {filteredMachineList.length === 0 ? (
                      <div>No machines found</div>
                    ) : (
                      <>
                        <CustomInput
                          type="checkbox"
                          id="selectAll"
                          label="Select All"
                          checked={isAllMachineSelect}
                          onChange={toggleSelectAll}
                          className="m-1"
                        />
                        {filteredMachineList.map((machine) => {
                          const isChecked = selectedMachine.includes(String(machine.machine_id));

                          return (
                            <CustomInput
                              key={machine.machine_id}
                              type="checkbox"
                              id={machine.machine_id}
                              label={`${machine.name} (${machine.serial_number || machine.machine_id})`}
                              value={machine.machine_id}
                              checked={isChecked}
                              onChange={handleMachineSelection}
                              className="m-1"
                            />
                          );
                        })}
                      </>
                    )}
                  </div>
                )}
              </Grid>

              {/* date selection  */}
              <Grid item xs={4} className='mt--1'>
                <DatePicker
                  selected={startDate}
                  onChange={(update) => {
                    setDateRange(update);
                    handleDateChange(update);
                  }}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  isClearable
                  dateFormat="dd/MM/yyyy"  // Add this line for dd/mm/yyyy format
                  customInput={
                    <TextField
                      variant="outlined"
                      label={
                        <>
                          Date range <span style={{ color: 'red' }}>*</span>
                        </>
                      }
                      sx={{ width: '101%' }}
                    />
                  }
                  maxDate={startDate ? (() => {
                    const maxDate = new Date(startDate);
                    maxDate.setMonth(maxDate.getMonth() + 3);
                    maxDate.setDate(0); // Set to last day of previous month
                    return new Date(Math.min(maxDate, new Date()));
                  })() : new Date()}
                  minDate={new Date(today.setDate(today.getDate() - 30))}
                  wrapperClassName="date-picker-wrapper"
                  calendarClassName="date-picker-calendar"
                />
              </Grid>

            </Grid>

            <Grid item xs={12} className='mt--2'>
              <DashBoardCard />
            </Grid>

            <Grid item xs={12} className='mt--4'>
              <ChartScreen data={chartData} startDate={startDate} endDate={endDate} />
            </Grid>

            <Grid item xs={12} className='mt--2'>
              <AlertNotification />
            </Grid>

          </Grid>
        </Box>
      </Container>

    </>
  );
};

export default Dashboard;
